import React, { Component } from 'react';
import './index.css'
import { withTranslation, WithTranslationProps } from 'react-i18next'
import icon_reportDetail_head from "../../images/icon_reportDetail_head.png"
import icon_greekFeet_right from "./images/icon_greekFeet_right.png"
import icon_greekFeet_left from "./images/icon_greekFeet_left.png"
import icon_egyptianFeet_right from "./images/icon_egyptianFeet_right.png"
import icon_egyptianFeet_left from "./images/icon_egyptianFeet_left.png"
import icon_romanFeet_right from "./images/icon_romanFeet_right.png"
import icon_romanFeet_left from "./images/icon_romanFeet_left.png"
import * as THREE from 'three'
import { OrbitControls } from 'three-orbitcontrols-ts'
import { STLLoader } from 'three/examples/jsm/loaders/STLLoader'
import { Spin } from 'antd'
import JSZip from "jszip"
import axios from 'axios';

interface PropsType {
	data: any
	inExport: boolean
}

let frame: any = null


class Index extends Component<PropsType & WithTranslationProps> {


	state = {
		frontFeetImgLeft: '',
		frontFeetImgRight: '',
		backFeetImgLeft: '',
		backFeetImgRight: '',
		threeDLoad: false,
	}

	componentDidMount() {
		const { data } = this.props
		if (data) {
			try {
				this.initThree(data)
			} catch (error) {

			}
		}
	}

	componentWillUnmount() {
		// 离开页面关闭动画（避免内存泄漏）
		window.cancelAnimationFrame(frame)
	}


	initThree(data: any) {

		const that = this;
		let cameraLeft: any, sceneLeft: any, rendererLeft: any, groupLeft: any;
		let cameraRight: any, sceneRight: any, rendererRight: any, groupRight: any;

		let containerLeft: any = document.getElementById('scan-threeD-left');
		let containerRight: any = document.getElementById('scan-threeD-right');

		if (containerLeft === null || containerRight === null) {
			return;
		}
		let width = containerLeft.offsetWidth;
		let height = containerLeft.offsetHeight;

		try {
			initLeft();
			initRight();
			console.log(process.env.NODE_ENV)
			if(process.env.NODE_ENV == "production") {
				animate()
			}
		} catch (error) {

		}


		function initLeft() {
			console.log('init three left');
			// let renderer;
			let container = containerLeft;
			sceneLeft = new THREE.Scene();
			groupLeft = new THREE.Group();

			/**
			 * 相机
			*/
			cameraLeft = new THREE.PerspectiveCamera(70, width / height, 1, 2000)
			cameraLeft.position.set(0, 250, 450)
			cameraLeft.lookAt(sceneLeft.position)

			/**
			 * 轨道控制器
			 */
			let orbitControls = new OrbitControls(cameraLeft, container)
			orbitControls.enableZoom = false
			orbitControls.autoRotateSpeed = 1

			/**
			 * 光源
			 */
			let ambi = new THREE.AmbientLight(0x4d4d4d)
			sceneLeft.add(ambi)

			// 平行光
			var directionalLight = new THREE.DirectionalLight(0xffffff);
			directionalLight.position.set(-20, 30, 10);
			directionalLight.castShadow = true;
			sceneLeft.add(directionalLight);


			var directionalLight3 = new THREE.DirectionalLight(0xffffff);
			directionalLight3.position.set(20, -30, -10);
			directionalLight3.castShadow = true;
			sceneLeft.add(directionalLight3);

			/**
			 * 引入stl模型
			 */
			let stl = new STLLoader()
			if (data.left.model3dUrl.search(".stl") !== -1) {
				stl.load(data.left.model3dUrl, function (geometry) {
					// 创建纹理
					var mat = new THREE.MeshPhongMaterial({
						color: 0x01c1ce,
						flatShading: true,
						side: THREE.DoubleSide,
					})
					var mesh = new THREE.Mesh(geometry, mat)

					//缩放
					mesh.scale.set(2, 2, 2)
					geometry.center() //居中显示
					groupLeft.add(mesh)

					that.setState({
						leftMesh: mesh
					})
					that.drawImg(rendererLeft, sceneLeft, mesh, 'left', container);
				})
			}
			else {
				axios.get(data.left.model3dUrl, { responseType: "arraybuffer" }).then(resp => {
					let files = new window.File([resp.data], 'zipFile', { type: 'zip' })
					var new_zip = new JSZip();
					// 解压缩文件对象
					new_zip.loadAsync(files)
						.then(function (result) {
							// 压缩包的模型文件列表
							let fileList = result.files
							for (let key in fileList) {
								// 读取模型文件内容
								(new_zip.file(key) as any).async("arraybuffer").then(content => {
									// Blob构造文件地址，通过url加载模型
									let blob = new Blob([content])
									let modelUrl = URL.createObjectURL(blob)
									stl.load(modelUrl, function (geometry) {
										// 创建纹理
										var mat = new THREE.MeshPhongMaterial({
											color: 0x01c1ce,
											flatShading: true,
											side: THREE.DoubleSide,
										})
										var mesh = new THREE.Mesh(geometry, mat)

										//缩放
										mesh.scale.set(2, 2, 2)
										geometry.center() //居中显示
										groupLeft.add(mesh)

										that.setState({
											leftMesh: mesh
										})
										that.drawImg(rendererLeft, sceneLeft, mesh, 'left', container);
									})
								})

							}
						});
				})
			}


			/**
			 * 渲染器
			 */
			rendererLeft = new THREE.WebGLRenderer(
				{ preserveDrawingBuffer: true, alpha: true }
			)
			// 背景颜色
			rendererLeft.setClearColor(0xffffff)
			// 设置设备像素比
			rendererLeft.setPixelRatio(window.devicePixelRatio)
			rendererLeft.setSize(width, height)

			sceneLeft.add(groupLeft)
			container.appendChild(rendererLeft.domElement)

		}

		function initRight() {
			console.log('init three right');
			// let renderer;
			let container = containerRight;
			sceneRight = new THREE.Scene();
			groupRight = new THREE.Group();

			/**
			 * 相机
			*/
			cameraRight = new THREE.PerspectiveCamera(70, width / height, 1, 2000)
			cameraRight.position.set(0, 250, 450)
			cameraRight.lookAt(sceneRight.position)

			/**
			 * 轨道控制器
			 */
			let orbitControls = new OrbitControls(cameraRight, container)
			orbitControls.enableZoom = false
			orbitControls.autoRotateSpeed = 1

			/**
			 * 光源
			 */
			let ambi = new THREE.AmbientLight(0x4d4d4d)
			sceneRight.add(ambi)

			// 平行光
			var directionalLight = new THREE.DirectionalLight(0xffffff);
			directionalLight.position.set(20, 30, 10);
			directionalLight.castShadow = true;
			sceneRight.add(directionalLight);


			var directionalLight3 = new THREE.DirectionalLight(0xffffff);
			directionalLight3.position.set(-20, -30, -10);
			directionalLight3.castShadow = true;
			sceneRight.add(directionalLight3);

			/**
			 * 引入stl模型
			 */
			let stl = new STLLoader()
			if (data.right.model3dUrl.search(".stl") !== -1) {
				stl.load(data.right.model3dUrl, function (geometry) {
					// 创建纹理
					var mat = new THREE.MeshPhongMaterial({
						color: 0x01c1ce,
						flatShading: true,
						side: THREE.DoubleSide,
					});
					var mesh = new THREE.Mesh(geometry, mat)

					mesh.scale.set(2, 2, 2) //缩放
					geometry.center() //居中显示
					groupRight.add(mesh)

					that.drawImg(rendererRight, sceneRight, mesh, 'right', container);

					that.setState({
						rightMesh: mesh
					})
				})
			}
			else {
				axios.get(data.right.model3dUrl, { responseType: "arraybuffer" }).then(resp => {
					let files = new window.File([resp.data], 'zipFile', { type: 'zip' })
					var new_zip = new JSZip();
					new_zip.loadAsync(files).then(function (result) {
						let fileList = result.files;
						for (let key in fileList) {
							(new_zip.file(key) as any).async("arraybuffer").then(content => {
								let blob = new Blob([content])
								let modelUrl = URL.createObjectURL(blob)
								stl.load(modelUrl, function (geometry) {
									// 创建纹理
									var mat = new THREE.MeshPhongMaterial({
										color: 0x01c1ce,
										flatShading: true,
										side: THREE.DoubleSide,
									});
									var mesh = new THREE.Mesh(geometry, mat)

									mesh.scale.set(2, 2, 2) //缩放
									geometry.center() //居中显示
									groupRight.add(mesh)

									that.drawImg(rendererRight, sceneRight, mesh, 'right', container);

									that.setState({
										rightMesh: mesh
									})
								})
							})
						}
					})
				})
			}


			/**
			 * 渲染器
			 */
			rendererRight = new THREE.WebGLRenderer(
				{ preserveDrawingBuffer: true, alpha: true }
			)
			// 背景颜色
			rendererRight.setClearColor(0xffffff)
			// 设置设备像素比
			rendererRight.setPixelRatio(window.devicePixelRatio)
			rendererRight.setSize(width, height)

			sceneRight.add(groupRight)
			container.appendChild(rendererRight.domElement)
		}

		function animate() {
			frame = requestAnimationFrame(animate)
			render()
		}

		function render() {
			rendererRight.render(sceneRight, cameraRight)
			rendererLeft.render(sceneLeft, cameraLeft)
		}

	}

	drawImg(threeRender, threeScene, mesh, direction: string, container) {

		let camera: any;
		let width = container.getBoundingClientRect().width;
		let height = container.getBoundingClientRect().height;

		threeRender.setClearColor(0x000000, 0);
		camera = new THREE.PerspectiveCamera(70, width / height, 1, 2000);

		mesh.rotation.x = - Math.PI / 1.5; // 后视图
		if (direction === 'left') {
			mesh.rotation.z = - Math.PI / 2;
		}
		else {
			mesh.rotation.z = - Math.PI / 1.9;
		}

		camera.position.set(0, 200, 500);
		camera.lookAt(threeScene.position);
		threeRender.render(threeScene, camera);
		let imgBack = threeRender.domElement.toDataURL();

		mesh.rotation.x = - Math.PI / 24;

		camera.position.set(0, 200, 500);
		camera.lookAt(threeScene.position);
		threeRender.render(threeScene, camera);
		let imgFront = threeRender.domElement.toDataURL();

		const {
			frontFeetImgLeft,
			frontFeetImgRight,
		} = this.state;
		let threeDLoad = false;
		if (direction === 'left') {
			if (frontFeetImgRight) {
				threeDLoad = true;
			}
			this.setState({
				frontFeetImgLeft: imgFront,
				backFeetImgLeft: imgBack,
				threeDLoad: threeDLoad,
			})
		}
		else {
			if (frontFeetImgLeft) {
				threeDLoad = true;
			}
			this.setState({
				frontFeetImgRight: imgFront,
				backFeetImgRight: imgBack,
				threeDLoad: threeDLoad,
			})
		}

	}

	returnHallexValgusLevel = (deg) => {
		const i18n = this.props.i18n;
		// switch (key) {
		// 	case "HALLUX_VARUS_SERVER": return i18n?.t("severeHalluxVarus");
		// 	case "HALLUX_VARUS_MILD": return i18n?.t("mildHalluxVarus");
		// 	case "HALLEX_VALGUS_LEVEL_NORMAL": return i18n?.t("valgusAngleNormal");
		// 	case "HALLEX_VALGUS_MILD": return i18n?.t("mildHalluxValgus");
		// 	case "HALLEX_VALGUS_SEVERE": return i18n?.t("severeHalluxValgus");
		// 	default: return "";
		// }
		if (deg) {
			deg = +deg.toFixed(1);
		}
		let level = ""
		if (deg < 16) {
			return i18n?.t("valgusAngleNormal")
		}
		else if (deg < 30) {
			return i18n?.t("valgusAngleMild") || "";
		}
		else if (deg < 40) {
			return i18n?.t("valgusAngleModerate") || "";
		}
		else {
			return i18n?.t("valgusAngleSevere") || "";
		}
	}

	returnHallexValgusData = (left, right) => {
		const i18n = this.props.i18n;
		if (left) {
			left = +left.toFixed(1);
		}
		if (right) {
			right = +right.toFixed(1);
		}
		if (left >= 16 || right >= 16) {
			return {
				define: i18n?.t("valgusAngleMildDefine"),
				influence: i18n?.t("valgusAngleMildInfluence"),
				shoeAdvice: i18n?.t("valgusAngleMildShoeAdvice"),
				exercise: i18n?.t("valgusAngleMildExercise"),
			}
		}
		else {
			return {
				define: i18n?.t("valgusAngleNormalDefine"),
				influence: i18n?.t("valgusAngleNormalInfluence"),
				shoeAdvice: i18n?.t("valgusAngleNormalShoeAdvice"),
				exercise: i18n?.t("valgusAngleNormalExercise"),
			}

		}

	}

	returnFootTypeText = (key) => {
		const i18n = this.props.i18n;
		switch (key) {
			case "GREEK":  /* 希腊脚 */
				return {
					type: i18n?.t("greekFeet"),
					define: i18n?.t("greekFeetDefine"),
					influence: i18n?.t("greekFeetInfluence"),
					chaussure: i18n?.t("greekFeetChaussure"),
					trait: i18n?.t("greekFeetTrait"),
				};
			case "ROMAN":  /* 罗马脚 */
				return {
					type: i18n?.t("romanFeet"),
					define: i18n?.t("romanFeetDefine"),
					influence: i18n?.t("romanFeetInfluence"),
					chaussure: i18n?.t("romanFeetChaussure"),
					trait: i18n?.t("romanFeetTrait"),
				};
			case "EGYPTIAN": /* 埃及脚 */
				return {
					type: i18n?.t("egyptianFeet"),
					define: i18n?.t("egyptianFeetDefine"),
					influence: i18n?.t("egyptianFeetInfluence"),
					chaussure: i18n?.t("egyptianFeetChaussure"),
					trait: i18n?.t("egyptianFeetTrait"),
				};
			default:
				return {
					type: "",
					define: "",
					influence: "",
					chaussure: "",
					trait: "",
				};
		}
	}

	returnFootTypeImgLeft = (key) => {
		switch (key) {
			case "GREEK": return icon_greekFeet_left; /* 希腊脚 */
			case "ROMAN": return icon_romanFeet_left; /* 罗马脚 */
			case "EGYPTIAN": return icon_egyptianFeet_left; /* 埃及脚 */
			default: return "";
		}
	}

	returnFootTypeImgRight = (key) => {
		switch (key) {
			case "GREEK": return icon_greekFeet_right; /* 希腊脚 */
			case "ROMAN": return icon_romanFeet_right; /* 罗马脚 */
			case "EGYPTIAN": return icon_egyptianFeet_right; /* 埃及脚 */
			default: return "";
		}
	}

	returnHeelValgusLevel = (deg) => {
		const i18n = this.props.i18n;
		if (deg) {
			deg = +deg.toFixed(1)
		}
		if (deg <= -5) {
			return i18n?.t("inversion");
		}
		else if (deg <= -2) {
			return i18n?.t("mildInversion");
		}
		else if (deg <= 5) {
			return i18n?.t("normal");
		}
		else if (deg <= 8) {
			return i18n?.t("mildEversion");
		}
		else {
			return i18n?.t("eversion");
		}
	}

	returnHeelValgusData = (left, right) => {
		const i18n = this.props.i18n;
		if (left) {
			left = +left.toFixed(1)
		}
		if (right) {
			right = +right.toFixed(1)
		}
		let deg = right;
		if (Math.abs(left) > Math.abs(right)) {
			deg = left;
		}
		if (deg <= -5) {
			return {
				define: i18n?.t("inversionDefine"),
				influence: i18n?.t("inversionInfluence"),
				shoeAdvice: i18n?.t("inversionShoeAdvice"),
				exercise: i18n?.t("inversionExercise"),
			}
		}
		else if (deg <= -2) {
			return {
				define: i18n?.t("mildInversionDefine"),
				influence: i18n?.t("mildInversionInfluence"),
				shoeAdvice: i18n?.t("mildInversionShoeAdvice"),
				exercise: i18n?.t("mildInversionExercise"),
			}
		}
		else if (deg <= 5) {
			return {
				define: i18n?.t("heelValgusNormalDefine"),
				influence: i18n?.t("heelValgusNormalInfluence"),
				shoeAdvice: i18n?.t("heelValgusNormalShoeAdvice"),
				exercise: i18n?.t("heelValgusNormalExercise"),
			}
		}
		else if (deg <= 8) {
			return {
				define: i18n?.t("mildEversionDefine"),
				influence: i18n?.t("mildEversionInfluence"),
				shoeAdvice: i18n?.t("mildEversionShoeAdvice"),
				exercise: i18n?.t("mildEversionExercise"),
			}
		}
		else {
			return {
				define: i18n?.t("eversionDefine"),
				influence: i18n?.t("eversionInfluence"),
				shoeAdvice: i18n?.t("eversionShoeAdvice"),
				exercise: i18n?.t("eversionExercise"),
			}
		}
	}

	render() {

		const i18n = this.props.i18n;
		if (!i18n) return;
		const left = this.props.data.left || {};
		const right = this.props.data.right || {};
		const {
			frontFeetImgLeft, frontFeetImgRight,
			backFeetImgLeft, backFeetImgRight,
		} = this.state;
		const threeDLoad = this.state.threeDLoad;
		const inExport = this.props.inExport;

		let footType = {
			left: {
				...this.returnFootTypeText(left.footType),
				img: this.returnFootTypeImgLeft(left.footType),
			},
			right: {
				...this.returnFootTypeText(right.footType),
				img: this.returnFootTypeImgRight(right.footType),
			}
		}

		let hallexValgus = {
			...this.returnHallexValgusData(left.halluxAngle, right.halluxAngle),
			leftLevel: this.returnHallexValgusLevel(left.halluxAngle),
			rightLevel: this.returnHallexValgusLevel(right.halluxAngle),
		}

		let heelValgus = {
			...this.returnHeelValgusData(left.angleOfVarus, right.angleOfVarus),
			leftLevel: this.returnHeelValgusLevel(left.angleOfVarus),
			rightLevel: this.returnHeelValgusLevel(right.angleOfVarus)
		}

		return (
			<div className={inExport ? "scan-typeAndSize print" : "scan-typeAndSize"}>
				<div className='footType'>
					<p className="reportCom-container-title">
						<span>{i18n.t("footType")}</span>
					</p>
					<div className='footTypeContent'>
						<div className='value-imgs'>
							<p>{i18n.t("left")}: <span>{footType.left.type}</span></p>
							<img src={footType.left.img} alt="left feet" />
						</div>
						<div className='value-imgs'>
							<p>{i18n.t("right")}: <span>{footType.right.type}</span></p>
							<img src={footType.right.img} alt="right feet" />
						</div>
						<ul>
							<li className='comText'>
								{/* <div>
								<p>{i18n.t("detectionDefinition")}</p>
								<p>{footType.left.define}</p>
							</div> */}
								<div>
									<p>{i18n.t("footTrait")}</p>
									<p>{footType.left.trait}</p>
								</div>
								<div>
									<p>{i18n.t("footInfluence")}</p>
									<p>{footType.left.influence}</p>
								</div>
								<div>
									<p>{i18n.t("suitableChaussure")}</p>
									<p>{footType.left.chaussure}</p>
								</div>
							</li>
							<li className='comText'>
								{/* <div>
								<p>{i18n.t("detectionDefinition")}</p>
								<p>{footType.right.define}</p>
							</div> */}
								{/* <div>
								<p>{i18n.t("footTrait")}</p>
								<p>{footType.right.trait}</p>
							</div>
							<div>
								<p>{i18n.t("footInfluence")}</p>
								<p>{footType.right.influence}</p>
							</div>
							<div>
								<p>{i18n.t("suitableChaussure")}</p>
								<p>{footType.right.chaussure}</p>
							</div> */}
							</li>
						</ul>
					</div>
				</div>
				<div className='twoBox'>
					<div className="valgusBox">
						<p className="reportCom-container-title">
							{/* <img src={icon_reportDetail_head} alt="icon head" /> */}
							<span>{i18n.t("valgusAngle")}</span>
						</p>
						<div className="comValue">
							<p>
								{i18n.t("left")}:
								<span>
									{left.halluxAngle ? left.halluxAngle.toFixed(1) + "°" : left.halluxAngle + "°"}
									({hallexValgus.leftLevel})
								</span>
							</p>
							<p>
								{i18n.t("right")}:
								<span>
									{right.halluxAngle ? right.halluxAngle.toFixed(1) + "°" : right.halluxAngle + "°"}
									({hallexValgus.rightLevel})
								</span>
							</p>
						</div>
						<p className="typeAndSizeDes">
							{/* <span>{i18n?.t("severeHalluxVarus")}</span> &lt; */}
							{/* <span> (0 - 5) {i18n?.t("mildHalluxVarus")}</span> &lt; */}
							<span> {i18n?.t("valgusAngleNormal")}</span> &lt;
							<span> (16 - 30) {i18n?.t("mildHalluxValgus")}</span> &lt;
							<span> {i18n?.t("severeHalluxValgus")}</span>
						</p>
						<div className='threeImgContainer'>
							{
								!threeDLoad ?
									(
										<div className='threeSpin'><Spin size="large" /></div>
									) :
									(
										<div className={inExport ? 'threeImg print' : 'threeImg hidden'}>
											<img src={frontFeetImgLeft} alt="valgusAngle" />
											<img src={frontFeetImgRight} alt="valgusAngle" />
										</div>
									)
							}
						</div>
						<div className={inExport ? "flex-fixed hidden" : "flex-fixed"}>
							<div id="scan-threeD-left"></div>
							<div id="scan-threeD-right"></div>
						</div>
						<div className='comText'>
							<div className='comText-row1'>
								<p>{i18n.t("detectionDefinition")}</p>
								<p>{hallexValgus.define}</p>
							</div>
							<div className='comText-row2'>
								<p>{i18n.t("footInfluence")}</p>
								<p>{hallexValgus.influence}</p>
							</div>
							<div>
								<p>{i18n.t("shoeSelectionAdvice")}</p>
								<p>{hallexValgus.shoeAdvice}</p>
							</div>
							<div>
								<p>{i18n.t("recommendedExercise")}</p>
								<p>{hallexValgus.exercise}</p>
							</div>
						</div>
					</div>
					<div className="heelValgus">
						<p className="reportCom-container-title">
							{/* <img src={icon_reportDetail_head} alt="icon head" /> */}
							<span>{i18n.t("heelValgus")}</span>
						</p>
						<div className="comValue">
							<p>
								{i18n.t("left")}:
								<span>
									{left.angleOfVarus ? left.angleOfVarus.toFixed(1) + "°" : left.angleOfVarus + "°"}
									({heelValgus.leftLevel})
								</span>
							</p>
							<p>
								{i18n.t("right")}:
								<span>
									{right.angleOfVarus ? right.angleOfVarus.toFixed(1) + "°" : right.angleOfVarus + "°"}
									({heelValgus.rightLevel})
								</span>
							</p>
						</div>
						<p className="typeAndSizeDes">
							<span>{i18n?.t("inversion")}</span> &lt;
							<span> (-5 - -2) {i18n?.t("mildInversion")}</span> &lt;
							<span> (-2 - 5) {i18n?.t("normal")}</span> &lt;
							<span> (5 - 8) {i18n?.t("mildEversion")}</span> &lt;
							<span> {i18n?.t("eversion")}</span>
						</p>
						<div className={inExport ? 'heelValgus-threeImg print' : 'heelValgus-threeImg'}>
							{
								!threeDLoad ?
									(
										<div><Spin size="large" /></div>
									) :
									(
										<div>
											<img src={backFeetImgLeft} alt="valgusAngle" />
											<img src={backFeetImgRight} alt="valgusAngle" />
										</div>
									)
							}
						</div>
						<div className='comText'>
							<div className='comText-row1'>
								<p>{i18n.t("detectionDefinition")}</p>
								<p>{heelValgus.define}</p>
							</div>
							<div className='comText-row2'>
								<p>{i18n.t("footInfluence")}</p>
								<p>{heelValgus.influence}</p>
							</div>
							<div>
								<p>{i18n.t("shoeSelectionAdvice")}</p>
								<p>{heelValgus.shoeAdvice}</p>
							</div>
							<div>
								<p>{i18n.t("recommendedExercise")}</p>
								<p>{heelValgus.exercise}</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default withTranslation()(Index)